import { FindParamsDefault } from './find-params-default';

export interface FindCharitiesParams extends FindParamsDefault {
  organization_id?: string;
  courier_enabled?: boolean;
  courier_terms_accepted?: boolean;
  discount_enabled?: boolean;
}
